<div class="feature-gympass-wrapper">
  <div class="feature-gympass-left-wrapper">
    <div class="feature-gympass-subsidies-wrapper">
      <p class="feature-label">Default subsidy</p>
      <app-select-dropdown
        [options]="productSubsidyNames"
        [(selected)]="defaultSubsidyNameSelected"
        [disabled]="readMode()"
        (handleSelect)="handleDefaultSubsidy($event)"
      ></app-select-dropdown>
    </div>
    <div class="feature-gympass-member-buyup-wrapper">
      <p class="feature-label">Allow Member Buyup</p>
      <app-toggle
        class="feature-toggle"
        (handleChecked)="handleMemberBuyup()"
        [checked]="memberBuyupEnabled()"
        [color]="ToggleHexColor.GREEN"
        [disabled]="readMode()"
        size="small"
        testId="feature-memberbuyup-toggle"
      ></app-toggle>
    </div>
    @if (memberBuyupEnabled()) {
    <div class="feature-gympass-enrollment-fee-wrapper">
      <p class="feature-label">Enrollment Fee</p>
      <app-toggle
        class="feature-toggle"
        (handleChecked)="handleEnrollmentFee()"
        [checked]="enrollmentFeeEnabled()"
        [color]="ToggleHexColor.GREEN"
        [disabled]="readMode()"
        size="small"
        testId="feature-enrollment-fee-toggle"
      ></app-toggle>
    </div>
    } @if (memberBuyupEnabled()) {
    <div class="feature-gympass-discount-wrapper">
      <p class="feature-label">Include Discount</p>
      <app-toggle
        class="feature-toggle"
        (handleChecked)="handleDiscount()"
        [checked]="discountEnabled()"
        [color]="ToggleHexColor.GREEN"
        [disabled]="readMode()"
        size="small"
        testId="feature-discount-toggle"
      ></app-toggle>
    </div>
    } @if (memberBuyupEnabled() && discountEnabled()) {
    <div class="feature-gympass-discount-amount-wrapper">
      <p class="feature-label">Discount Amount</p>
      <app-select-dropdown
        [options]="productDiscountAmounts"
        [(selected)]="defaultDiscountAmountSelected"
        [disabled]="readMode()"
        (handleSelect)="handleDiscountAmount($event)"
      ></app-select-dropdown>
    </div>
    }
  </div>
  <div class="feature-available-tiers-wrapper">
    <p class="feature-label">Available Tiers</p>
    <div class="feature-tier-cards">
      @for (productDisplayTier of productDisplayTiers(); track
      productDisplayTier.productTier.id) {
      <div
        class="feature-tier-card"
        [ngClass]="{
        'feature-tier-card--disabled': !productDisplayTier.enabled,

      }"
      >
        <p class="feature-tier-title">
          {{ productDisplayTier.name }} -
          {{
            productDisplayTier.dollarAmount === 0
              ? ('common.free' | translate)
              : '$' + productDisplayTier.dollarAmount
          }}
        </p>
        <ul class="feature-tier-description-list">
          @for (description of productDisplayTier.description; track
          description) {
          <li>{{ description }}</li>
          }
        </ul>
      </div>
      }
    </div>
  </div>
</div>
